class BlogsGuidesTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-blogs-guides-tab]');
    this.panels = this.querySelectorAll('[data-blogs-guides-panel]');
    this.viewAllButtons = this.querySelectorAll('[data-blogs-guides-view-all]');

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.blogsGuidesTab));
    });
  }

  activate(tabId) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.blogsGuidesTab === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.blogsGuidesPanel === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.viewAllButtons.forEach((button) => {
      const isActive = button.dataset.blogsGuidesViewAll === tabId;
      button.hidden = !isActive;
    });
  }
}

if (!customElements.get('blogs-guides-tabs')) {
  customElements.define('blogs-guides-tabs', BlogsGuidesTabs);
}
